import React from 'react';
import Reveal from '../../../shared/Reveal/Reveal';
import earnImage from '../../../../assets/images/wealthandsavingsdetails/earn/main.jpg';
import './Earn.css';

const Earn = ({ title, paragraphs, image }) => {
  if (!title || !paragraphs?.length) {
    return null;
  }

  return (
    <section className="wealth-earn">
      <div className="wealth-earn__inner">
        <Reveal className="wealth-earn__media">
          <img
            className="wealth-earn__image"
            src={image || earnImage}
            alt=""
            aria-hidden="true"
          />
        </Reveal>

        <Reveal className="wealth-earn__copy" delay={80}>
          <h2 className="wealth-earn__title">{title}</h2>
          {paragraphs.map((paragraph) => (
            <p key={paragraph} className="wealth-earn__text">
              {paragraph}
            </p>
          ))}
        </Reveal>
      </div>
    </section>
  );
};

export default Earn;
